<template>
  <div class="sn-page sn-assembly sn-f-c-c toast-page">
    <div class="sn-f-col-c-c toast-blank">
      <div class="toast-caption">{{ option.caption }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'toast',
  data() {
    return {
      option: {}
    };
  },
  created: function() {
    this.option = this.$sn.vuex.get('vuex_toast');
  }
};
</script>
<style lang="scss">
.toast-page {
  .toast-blank {
    @include fs(14);

    opacity: 0.9;
    clip-path: inset(0 0 0 0 round 16px);
    overflow: hidden;
    min-width: 200px;
    max-width: 400px;
    max-height: 80vh;
    background-color: $text1;
    color: $text7;
    border-radius: 16px;
    text-align: center;
    padding: 0 16px;

    .toast-caption {
      overflow: hidden;
      width: 100%;
      margin: 20px 0;
    }
  }
}
</style>
